import React, { useState, useMemo, Suspense } from 'react';
import './MedicinalPage.css';

const EnlargedImage = React.lazy(() => import('./EnlargedImage'));

const PhotoItem = React.memo(({ src, alt, onClick }) => (
  <div className="photo-item">
    <img
      src={src}
      alt={alt}
      className="photo-img"
      loading="lazy"
      onClick={onClick}
    />
  </div>
));

function MedicinalPage() {
  const totalImages = 17;
  const [viewAll, setViewAll] = useState(false);
  const [enlargedImage, setEnlargedImage] = useState(null);

  const visibleCount = viewAll ? totalImages : 6;

  const loadImage = (index) => `/images/medicinal_plant_exhibition/${index + 1}.jpg`;

  const visibleImages = useMemo(() => {
    return Array.from({ length: visibleCount }, (_, index) => ({
      src: loadImage(index),
      alt: `Medicinal ${index + 1}`,
    }));
  }, [visibleCount]);

  return (
    <div className="photos-container">
      <h2 className="photos-heading">MEDICINAL PLANT EXHIBITION</h2>

      {enlargedImage && (
        <Suspense fallback={<div className="loading-overlay">Loading...</div>}>
          <EnlargedImage image={enlargedImage} onClose={() => setEnlargedImage(null)} />
        </Suspense>
      )}

      <div className="photos-grid">
        {visibleImages.map((image, index) => (
          <PhotoItem
            key={index}
            src={image.src}
            alt={image.alt}
            onClick={() => setEnlargedImage(image.src)}
          />
        ))}
      </div>

      {!viewAll && totalImages > 6 && (
        <div className="view-all-btn-wrapper">
          <button className="view-all-btn" onClick={() => setViewAll(true)}>
            View All
          </button>
        </div>
      )}
    </div>
  );
}

export default MedicinalPage;
